import { NxExpertModule } from "@allianz/ng-aquila/config";
import { NX_DATE_LOCALE, NxDatepickerIntl } from "@allianz/ng-aquila/datefield";
import { NxDropdownIntl } from "@allianz/ng-aquila/dropdown";
import { NxMomentDateModule } from "@allianz/ng-aquila/moment-date-adapter";
import {
  AllianzIconModule,
  provideAllianzIcons,
} from "@allianz/ngx-brand-kit/icon";
import { APP_BASE_HREF, registerLocaleData } from "@angular/common";
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
import localePl from "@angular/common/locales/pl";
import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  BrowserAnimationsModule,
  provideAnimations,
} from "@angular/platform-browser/animations";
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
} from "@angular/router";
import { JwtModule } from "@auth0/angular-jwt";
import { TranslateModule } from "@ngx-translate/core";
import "moment/locale/pl";
import { routes } from "./app.routes";
import { dateInterceptor } from "./shared/interceptors/date.interceptor";
import { errorInterceptor } from "./shared/interceptors/error.interceptor";
import { AppTranslateModule } from "./shared/modules/app-translate.module";
import { FaIconsModule } from "./shared/modules/fa-icons.module";
import { NxDatepickerIntlProvider } from "./shared/ndbx-translations/nx-date-picker-initl-provider";
import { NxDropdownIntlProvider } from "./shared/ndbx-translations/nx-drop-down-initl-provider";
import { ProcessStore } from "./shared/store/process.store";
registerLocaleData(localePl);

export function tokenGetter() {
  return sessionStorage.getItem("glob-api-user-token");
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    importProvidersFrom([
      NxExpertModule,
      AllianzIconModule,
      AppTranslateModule,
      TranslateModule,
      FaIconsModule,
      BrowserModule,
      NxMomentDateModule,
      BrowserAnimationsModule,
      JwtModule.forRoot({
        config: {
          tokenGetter: tokenGetter,
          allowedDomains: [/.*/],
        },
      }),
      
    ]),
    provideAnimations(),
    provideAllianzIcons(),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([errorInterceptor, dateInterceptor]),
      withFetch(),
    ),
    { provide: LOCALE_ID, useValue: "pl-PL" },
    { provide: NX_DATE_LOCALE, useValue: "pl-PL" },
    provideAnimations(),
    provideAllianzIcons(),
    ProcessStore,
    {
      provide: NxDatepickerIntl,
      useClass: NxDatepickerIntlProvider,
    },
    {
      provide: NxDropdownIntl,
      useClass: NxDropdownIntlProvider,
    },
  ],
};
